import React, { useState } from 'react';
import {
  Table, TableBody, TableCell, MenuItem,
  Menu,
  Stack, Button,
  InputBase, TableContainer, TableHead, TableRow, Checkbox, Paper, IconButton, Chip
} from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Edit, Delete, ArrowDropDown, Search } from '@mui/icons-material';
import { styled } from '@mui/material/styles';
import moment from 'moment/moment';
import { useDispatch } from 'react-redux';
import DeleteModal from '../reusable/deleteModal/DeleteModal';
import CatPagination from '../reusable/catPagination/CatPagination';
import { useNavigate } from 'react-router-dom';
import Operations from '../reusable/Operations';
import { fomateDate } from '../../utils/fomateDate';
import DateSortMenu from '../reusable/DateSortMenu';
import { deleteCategoriesThunk, setEditCategory } from '../../redux/category/getAllCategorySlice';
import { Filter } from '../../Svg';
import { deletebomOrderThunk } from '../../redux/bomOrderSlice';


// Styled components using MUI's `styled` API
const TableContainerStyled = styled(TableContainer)(({ theme }) => ({
  borderRadius: 8,
  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
  border: '1px solid #E0E2E7',
}));

const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
  borderBottom: '1px solid #E6E1E5',
  padding: '4px 40px',
  fontSize: '14px',
  color: '#667085',
}));

const SearchInput = styled(Paper)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  borderRadius: '8px',
  boxShadow: 'none',
  border: `1px solid ${theme.palette.divider}`,
  width: '320px',
  fontFamily: `'Public Sans', sans-serif`,
}));
const HeaderCell = styled(TableCell)(({ theme }) => ({
  fontWeight: 'bold',
  backgroundColor: '#f8f9fa',
  color: '#495057',
  padding: '6px 0px 0px 20px',
  fontFamily: `'Public Sans', sans-serif !important`,

}));

const TableCells = styled(TableCell)(({ theme }) => ({
  paddingLeft: '20px',
  fontFamily: `'Public Sans', sans-serif !important`,
}));

const ActionIcons = styled(TableCell)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-start',
  paddingLeft: '6px',
  borderBottom: '1px solid rgba(224, 224, 224, 1)',
}));

const ProductText = styled(TableCell)(({ theme }) => ({
  color: '#495057',
  fontWeight: 'bold',
  paddingLeft: '20px',
  fontFamily: `'Public Sans', sans-serif !important`,
}));

const New = styled(Chip)(({ theme }) => ({
  backgroundColor: '#4A4C561A',
  color: '#4A4C56',
  fontWeight: 'bold',
  borderRadius: '4px',
  lineHeight: '24px',
  fontSize: '12px',
  fontFamily: `'Public Sans', sans-serif !important`,
}));

const Cancelled = styled(Chip)(({ theme }) => ({
  backgroundColor: '#FFF0EA',
  color: 'red',
  fontWeight: 'bold',
  borderRadius: '4px',
  lineHeight: '24px',
  fontSize: '14px',
  fontFamily: `'Public Sans', sans-serif !important`,
}));


const Processing = styled(Chip)(({ theme }) => ({
  backgroundColor: '#FFF0EA',
  color: '#F86624',
  fontWeight: 'bold',
  borderRadius: '4px',
  lineHeight: '24px',
  fontSize: '12px',
  fontFamily: `'Public Sans', sans-serif !important`,
}));

const Shiped = styled(Chip)(({ theme }) => ({
  backgroundColor: '#EAF8FF',
  color: '#2BB2FE',
  fontWeight: 'bold',
  borderRadius: '4px',
  lineHeight: '24px',
  fontSize: '12px',
  fontFamily: `'Public Sans', sans-serif !important`,
}));

const Delivered = styled(Chip)(({ theme }) => ({
  backgroundColor: '#E9FAF7',
  color: '#1A9882',
  fontWeight: 'bold',
  borderRadius: '4px',
  lineHeight: '24px',
  fontSize: '12px',
  fontFamily: `'Public Sans', sans-serif !important`,
}));






const AllBomOrderTable = ({ bomData, page, setPage, itemsPerPage, start, end, totalItems,selectedTab,handleDeleteClick,deleteCategory ,isModalOpen,setIsModalOpen,path, handleOpenMenu: onSort, allStatus, setAllStatus, statusOptions, dateOrder, onDateSort, statusOrder, onStatusSort, statusFilterOptions, statusFilterValue, onStatusFilterChange }) => {



  // Mirrors the parent's sort state: it sets the field and flips asc/desc on every click
  const [sortState, setSortState] = useState({ field: null, order: 'asc' });
  // const [selectedId, setSelectedId] = useState(null)
  // const [isModalOpen, setIsModalOpen] = useState(false);




  const dispatch = useDispatch()
  const navigate = useNavigate()




  //delete
  // const deleteCategory = () => {
  //   dispatch(deletebomOrderThunk(selectedId))
  //   setIsModalOpen(false);

  // }


  // //delete modal open
  // const handleDeleteClick = (id) => {
  //   setIsModalOpen(true);
  //   setSelectedId(id)
  // };
  const handleSort = (field) => {
    setSortState((prev) => ({ field, order: prev.order === 'asc' ? 'desc' : 'asc' }));
    onSort?.(field);
  };

  // Status column filters instead of sorting when the page provides a status setter (only on the "Total" tab)
  const canFilterStatus = Boolean(setAllStatus && statusOptions?.length) && selectedTab === 0;
  const [statusAnchorEl, setStatusAnchorEl] = useState(null);

  const handleStatusSelect = (value) => {
    setAllStatus(value);
    if (setPage) dispatch(setPage(1));
    setStatusAnchorEl(null);
  };

  const sortIconStyle = (field) => ({
    transform: sortState.field === field && sortState.order === 'asc' ? 'rotate(180deg)' : 'none',
    color: sortState.field === field ? '#512DA8' : 'inherit',
    transition: 'transform 0.2s',
  });


  return (
    <>


      <TableContainerStyled component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <HeaderCell>
                Order ID
                <IconButton onClick={() => handleSort('_id')} aria-label="Sort by Order ID">
                  <ArrowDropDown sx={sortIconStyle('_id')} />
                </IconButton>
              </HeaderCell>


              <HeaderCell>
                Products
                <IconButton onClick={() => handleSort('productCount')} aria-label="Sort by Products">
                  <ArrowDropDown sx={sortIconStyle('productCount')} />
                </IconButton>
              </HeaderCell>

              <HeaderCell>
                Date
                {onDateSort ?
                  <DateSortMenu order={dateOrder} onChange={onDateSort} ariaLabel="Sort by date" />
                  :
                  <IconButton onClick={() => handleSort('createdAt')} aria-label="Sort by Date">
                    <ArrowDropDown sx={sortIconStyle('createdAt')} />
                  </IconButton>
                }
              </HeaderCell>

              <HeaderCell>
                Customer
                <IconButton onClick={() => handleSort('user.fullName')} aria-label="Sort by Customer">
                  <ArrowDropDown sx={sortIconStyle('user.fullName')} />
                </IconButton>
              </HeaderCell>



              <HeaderCell>
                Total
                <IconButton onClick={() => handleSort('total')} aria-label="Sort by Total">
                  <ArrowDropDown sx={sortIconStyle('total')} />
                </IconButton>
              </HeaderCell>

              {/* <HeaderCell>
                Payment
                <IconButton onClick={(e) => handleOpenMenu(e, 'Category')}>
                  <ArrowDropDown />
                </IconButton>
              </HeaderCell> */}

              <HeaderCell>
                Status
                {onStatusSort ?
                  <DateSortMenu order={statusOrder} onChange={onStatusSort} ariaLabel="Filter or sort by status" statusOptions={statusFilterOptions} statusValue={statusFilterValue} onStatusChange={onStatusFilterChange} />
                  : canFilterStatus ?
                  <>
                    <IconButton onClick={(e) => setStatusAnchorEl(e.currentTarget)} aria-label="Filter by Status">
                      <ArrowDropDown sx={{ color: allStatus ? '#512DA8' : 'inherit' }} />
                    </IconButton>
                    <Menu anchorEl={statusAnchorEl} open={Boolean(statusAnchorEl)} onClose={() => setStatusAnchorEl(null)}>
                      <MenuItem selected={!allStatus} onClick={() => handleStatusSelect('')}>All</MenuItem>
                      {statusOptions.map((option) => (
                        <MenuItem key={option.value} selected={allStatus === option.value} onClick={() => handleStatusSelect(option.value)}>
                          {option.label}
                        </MenuItem>
                      ))}
                    </Menu>
                  </>
                  :
                  <IconButton onClick={() => handleSort('status')} aria-label="Sort by Status">
                    <ArrowDropDown sx={sortIconStyle('status')} />
                  </IconButton>
                }
              </HeaderCell>

              <HeaderCell>
                Action
              </HeaderCell>
            </TableRow>

          </TableHead>

          <TableBody >
            {bomData?.map((row) => (
              <TableRow key={row._id}>

                <ProductText sx={{ width: '13%' }}>{row._id}</ProductText>

                {/* <TableCells sx={{
                  width: '14%',

                }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <div>
                      {
                        row?.partList[0]?.photo ? <img src={row?.thumbnail?.photo} style={{ width: 44, height: 44, borderRadius: 2 }} /> : <img src="/assets/profile.png" />
                      }
                    </div>
                    <div>
                      <strong style={{ color: '#1D1F2C' }}>{row.name}</strong>
                      <div style={{ fontSize: '12px', color: '#667085', fontWeight: '500', }}>
                        {row.description}
                      </div>
                    </div>
                  </div>
                </TableCells> */}

                <ProductText sx={{ width: '12%' }}>{row?.productCount} products</ProductText>

                <ProductText sx={{ width: '12%' }}>{fomateDate(row.createdAt)}</ProductText>


                <TableCells sx={{
                  width: '10%',

                }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <div>
                      <strong style={{ color: '#1D1F2C' }}>{row?.user?.companyName}</strong>
                      <div style={{ fontSize: '12px', color: '#667085', fontWeight: '500', }}>
                        {row?.user?.fullName}
                      </div>
                    </div>
                  </div>
                </TableCells>

                <TableCells sx={{ width: '12%', fontSize: '12px', color: '#667085', fontWeight: '500' }}>
                  {row?.total}
                </TableCells>

                {/* <TableCells sx={{ width: '14%', fontSize: '12px', color: '#667085', fontWeight: '500' }}>
                  {fomateDate(row.createdAt)}
                </TableCells> */}


                <TableCells sx={{ width: '11%' }}>
                  {row?.status === "NEW" ? (
                    <New label="New" size="small" />
                  ) : row?.status === "DELIVERED" ? (
                    <Delivered label="Delivered" size="small" />
                  ) : row?.status === "PROCESSING" ? (
                    <Processing label="Processing" size="small" />
                  ) : row?.status === "CANCELLED" ? (
                    <Cancelled label="Cancelled" size="small" />
                  ) : (
                    <Shiped label="Shipped" size="small" />
                  )}
                </TableCells>


                <Operations sx={{ width: '8% !important' }}
                  TableCells={TableCells}
                  viewClick={() => navigate(`${path}/${row?._id}`)}
                  deleteClick={() => handleDeleteClick(row?._id)}
                  selectedTab={1}
                  />

                <DeleteModal
                  isOpen={isModalOpen}
                  heading={'category'}
                  onClose={() => setIsModalOpen(false)}
                  onDelete={deleteCategory}
                />
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <div>
          <CatPagination
            start={start}
            end={end}
            totalItems={totalItems}
            itemsPerPage={itemsPerPage}
            setPage={setPage}
            page={page}
          />
        </div>
      </TableContainerStyled>

    </>
  );
};

export default AllBomOrderTable;
